// extracted by mini-css-extract-plugin
var _1 = "MatchingItem_burgerIcon__ae625";
var _2 = "MatchingItem_icon__34f0f";
var _3 = "MatchingItem_item__1c727";
var _4 = "MatchingItem_placeholder__6023d";
var _5 = "MatchingItem_text__f2987";
export { _1 as "burgerIcon", _2 as "icon", _3 as "item", _4 as "placeholder", _5 as "text" }
